import React, { FC, ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';

import { Layouts } from 'components';
import { CheckedStateProvider } from 'providers';
import { useCapabilities } from 'hooks';
import * as paths from 'paths';

import { Companies, Landing, People } from './containers';
import { InsightsNav } from './components';
import theme from 'theme';

const styles = {
  container: {
    margin: '0 auto',
    maxWidth: theme.custom.layoutSingleColumnMaxWidth,
    [theme.breakpoints.down('xl')]: {
      paddingLeft: 2,
      paddingRight: 2,
    },
  },
} as const;

const OrganicInsightsController: FC = () => {
  const { pathname } = useLocation();
  const { needs } = useCapabilities();

  const hasOICTAPageOnly = needs('Feature.OICTAPageOnly');

  let main: ReactNode = null;
  switch (pathname) {
    case paths.insights:
      main = hasOICTAPageOnly ? (
        <Landing />
      ) : (
        <Box sx={styles.container}>
          <Landing />
        </Box>
      );
      break;
    case paths.insightsCompanies:
      main = <Companies />;
      break;
    case paths.insightsPeople:
      main = <People />;
      break;
  }

  if (hasOICTAPageOnly) {
    return <Layouts.App1Column main={main} />;
  }

  return (
    <CheckedStateProvider>
      <Layouts.App2Column desktopSplit="2/10" sidebar={<InsightsNav />} main={main} />
    </CheckedStateProvider>
  );
};

export default OrganicInsightsController;
